module.exports = __webpack_public_path__ + "img/tariff_SMS100.6621a4f7.svg";